import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { BaseReport } from '../../interfaces/standard-reports.interface';

@Component({
    selector: 'app-reporting-card',
    templateUrl: './reporting-card.template.html',
    styleUrls: ['./reporting-card.style.scss'],
    standalone: true,
    imports: [TranslateModule, PlatformModule, RouterLink],
})
export class ReportingCardComponent {
    @Input({ required: true }) report!: BaseReport;
    @Input() disableRouterLink?: boolean;
}
